<template>
  <div class="boxes">
    <header-bar
      :hpadding="false"
    />
    <article class="bg-pg">
      <div class="content">
        <p>Perennial Garden</p>
        <a
          class="button"
          href="https://pg.nybg.org/#/intro"
        >
          Go
        </a>
      </div>
    </article>
    <article class="bg-conservatory">
      <div class="content">
        <p>Palm Dome</p>
        <a
          class="button"
          href="https://experiences.nybg.org/conservatory/"
        >
          Go
        </a>
      </div>
    </article>
    <!-- <article class="bg-rbm">
      <div class="content">
        <p>Brazilian Modern: The Living Art of Roberto Burle Marx</p>
        <a
          class="button"
          href="https://experiences.nybg.org/burle-marx/"
        >
          Go
        </a>
      </div>
    </article> -->
  </div>
</template>

<script>

export default {
  name: 'Intro'
}
</script>

<style lang="scss" scoped>

.boxes {
  @include flex-vertical;
  background: black;
}
article {
  @include flex-vertical;
  @include flex-fill-vertical;
  padding: 2rem;
  background-color: black;
  background-size: cover;
  background-position: center;

  &.bg-pg {
    background-image: url(~@/assets/backgrounds/pg.jpg)
  }

  &.bg-rbm {
    background-image: url(~@/assets/backgrounds/rbm.jpg)
  }

  &.bg-conservatory {
    background-image: url(~@/assets/backgrounds/conservatory.jpg)
  }

  &:first-of-type {
    // padding-top: 0;
  }

  .content {
    @include flex-vertical;
    @include flex-fill-vertical;
    justify-content: space-around;
    background: white;
    padding: 1rem;
    flex: 1;

    > p {
      font-family: $font-serif;
      text-transform: uppercase;
      font-size: 1.2rem;
    }

    .button {
      align-self: center;
    }
  }
}
</style>
